import React, { Component } from "react"
import Loading from './../components/loading'
import Sidebar from '../components/sidebar'
import { Fade } from 'react-reveal';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Jumbotron from 'react-bootstrap/Jumbotron'
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import Breadcrumb from 'react-bootstrap/Breadcrumb'

class FAQ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      activeEventKey: 0
    };
  }

  componentDidMount() {
    fetch("/json/faq.json?v=" + process.env.REACT_APP_SITE_VERSION)
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            headers: {
              "Content-Type": "application/json"
            },
            items: result
          });
        },
        // Not: Burada hataları yakalamak önemlidir.
        // Bileşenimizde bug bulunmaması için, 'catch ()' bloğu yerine bulunan
        // bu blok içinde hatalar yakalanır.
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
  }
  render() {
    const { error, isLoaded, items } = this.state;
    if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return <Loading />;
    } else {
      return (
        <>
          <Jumbotron className="subpageHeader" fluid>
            <Fade>
              <Container>
                <h1>Sıkça Sorulan Sorular</h1>
                <Breadcrumb>
                  <Breadcrumb.Item href="/">Ana Sayfa</Breadcrumb.Item>
                  <Breadcrumb.Item active>Sıkça Sorulan Sorular</Breadcrumb.Item>
                </Breadcrumb>
              </Container>
            </Fade>
          </Jumbotron>
          <section>
            <Container>
              <Row>
                <Col className="subpageContent" sm={9}>
                  <Fade bottom cascade>
                    <h2>Sıkça Sorulan Sorular</h2>
                    <Accordion defaultActiveKey="0">
                      {
                        items.filter(items => items.isActive === true).map((faqs, i) => {

                          const htmlString = faqs.content;
                          return (
                            <Card>
                              <Accordion.Toggle as={Card.Header} variant="link" eventKey={`${faqs._id}`}>{faqs.title}</Accordion.Toggle>
                              <Accordion.Collapse eventKey={`${faqs._id}`}>
                                <Card.Body dangerouslySetInnerHTML={{ __html: htmlString }}></Card.Body>
                              </Accordion.Collapse>
                            </Card>
                          );
                        })
                      }
                    </Accordion>
                  </Fade>
                </Col>
                <Col sm={3}>
                  <Sidebar />
                </Col>
              </Row>
            </Container>
          </section>
        </>
      );
    }
  }
}

export default FAQ;